import React from 'react';
import styles from './PaymentComponent.module.css';
import { useAppConfig } from '../../context/AppConfigContext';

const TRIBUTE_BASE_URL = 'https://t.me/tribute/app?startapp=';

const PaymentTributeComponent = ({ tariff }) => {
  const { userInfo, telegrambot } = useAppConfig();

  const userId = userInfo?.userId || null;
  const telegramLinked = !!userInfo?.telegramId;
  const isTelegramWebApp = !!window?.Telegram?.WebApp?.initDataUnsafe?.user;

  const handlePay = () => {
    let productCode = null;

    if (tariff === 1) productCode = 'sG3N';
    else if (tariff === 2) productCode = 'sG3P';
    else if (tariff === 6) productCode = 'sG3Q';

    if (!productCode) {
      console.error('Unknown tariff', tariff);
      return;
    }

    // ✅ 1. Telegram WebApp ИЛИ уже связанный аккаунт
    if (isTelegramWebApp || telegramLinked) {
      const tributeLink = TRIBUTE_BASE_URL + productCode;
      window.location.href = tributeLink;
      return;
    }

    // ✅ 2. Браузер + нет Telegram → идём в бота
    if (userId && userInfo?.referralCode) {
		window.open(
		  `https://t.me/${telegrambot}?start=paytribute-${userInfo.referralCode}${tariff}`,
		  '_blank'
		);
      return;
    }

    // ❌ Фолбэк (на всякий случай)
    alert('Невозможно начать оплату. Пожалуйста, войдите в аккаунт.');
  };

  return (
    <button
      className={styles.tabButton}
      onClick={handlePay}
    >
      Tribute
    </button>
  );
};

export default PaymentTributeComponent;
